import React from "react";
import { useMutation } from "@tanstack/react-query";
import { submitPut } from "../../../../../../enums/queryFunction/Submit";
import { SnackbarContext } from "../../../../../../contexts/Snackbar";
import { WAREHOUSE_CODE_PREFIX } from "../../../../../../enums/ApiPaths";

export default function useUpdateWarehouseCodePrefix(clinicId) {
  const { handleSnackbar } = React.useContext(SnackbarContext);

  const mutation = useMutation({
    mutationFn: (data) => submitPut(`${WAREHOUSE_CODE_PREFIX}${clinicId}`, data),
  });

  async function updateCodePrefix(prefix, applyToExisting) {
    try {
      const response = await mutation.mutateAsync({ prefix, applyToExisting });
      handleSnackbar("success", "success");
      return response?.data ?? null;
    } catch (error) {
      handleSnackbar(error, "error");
      return null;
    }
  }

  return { updateCodePrefix, isUpdating: mutation.isPending };
}
